import { CampoTipoValidacion } from './CampoTipoValidacion';

export class TipoValidacion {
  public id: String;
  public codigo: string;
  public nombre: string;
  public campos: CampoTipoValidacion[];

  constructor(
    id: String,
    codigo: string,
    nombre: string,
    campos: CampoTipoValidacion[]
  ) {
    this.id = id;
    this.codigo = codigo;
    this.nombre = nombre;
    this.campos = campos;
  }
}
